var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.horizontal
        ? _c(
            "v-navigation-drawer",
            {
              staticClass: "vuely-sidebar",
              attrs: {
                app: "",
                fixed: "",
                width: 250
              },
              model: {
                value: _vm.drawer,
                callback: function callback($$v) {
                  _vm.drawer = $$v
                },
                expression: "drawer"
              }
            },
            [_vm.isServiceSidebar ? _c("ServiceSidebar") : _c("app-sidebar")],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }